import { apiClient } from './api.js';

// Test
export async function sendTestNotification(params: {
  userId: string;
  title: string;
  body: string;
  channels: string[];
  deepLink?: string;
}) {
  const res = await apiClient.post('/admin/marketing/test', params);
  return res.data.data;
}

export async function getTestHistory() {
  const res = await apiClient.get('/admin/marketing/test-history');
  return res.data.data;
}

// Campaigns
export async function createCampaign(params: {
  title: string;
  body: string;
  channels: string[];
  targetType: string;
  targetFilter?: Record<string, unknown>;
  deepLink?: string;
  scheduledAt?: string;
  templateId?: string;
}) {
  const res = await apiClient.post('/admin/marketing/campaigns', params);
  return res.data.data;
}

export async function listCampaigns(params: {
  page?: number;
  perPage?: number;
  status?: string;
  isTest?: boolean;
}) {
  const res = await apiClient.get('/admin/marketing/campaigns', { params });
  return res.data.data;
}

export async function getCampaign(id: string) {
  const res = await apiClient.get(`/admin/marketing/campaigns/${id}`);
  return res.data.data;
}

export async function updateCampaign(id: string, data: Record<string, unknown>) {
  const res = await apiClient.put(`/admin/marketing/campaigns/${id}`, data);
  return res.data.data;
}

export async function cancelCampaign(id: string) {
  const res = await apiClient.delete(`/admin/marketing/campaigns/${id}`);
  return res.data.data;
}

export async function sendCampaignNow(id: string) {
  const res = await apiClient.post(`/admin/marketing/campaigns/${id}/send-now`);
  return res.data.data;
}

// Queue
export async function getQueue() {
  const res = await apiClient.get('/admin/marketing/queue');
  return res.data.data;
}

// Templates
export async function listTemplates() {
  const res = await apiClient.get('/admin/marketing/templates');
  return res.data.data;
}

export async function createTemplate(params: {
  name: string;
  titleTemplate: string;
  bodyTemplate: string;
  category: string;
  variables: string[];
  channels?: string[];
}) {
  const res = await apiClient.post('/admin/marketing/templates', params);
  return res.data.data;
}

export async function updateTemplate(id: string, data: Record<string, unknown>) {
  const res = await apiClient.put(`/admin/marketing/templates/${id}`, data);
  return res.data.data;
}

export async function deleteTemplate(id: string) {
  const res = await apiClient.delete(`/admin/marketing/templates/${id}`);
  return res.data.data;
}

// Users with tokens
export async function getUsersWithTokens() {
  const res = await apiClient.get('/admin/marketing/users-with-tokens');
  return res.data.data;
}
